import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'
import axios from 'axios'

export default {
  getReminder ({limit = 9999, page = 1, project = '', isProjectReminder = true}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`]
    if (project && isProjectReminder) fullRequest.push(`project[]=${project}`)
    if (project && !isProjectReminder) fullRequest.push(`request[]=${project}`)
    const url = isProjectReminder ? 'reminders' : 'reminders/getReminderByRequest'
    return instCred.get(`${url}?${fullRequest.join('&')}`)
  },
  createReminder (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('reminders', body)
  },
  onEditReminder (body, _id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put(`reminders/${_id}`, body)
  },
  onReadReminder (_id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`reminders/readReminder/${_id}`)
  },
  deleteReminder (_id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete(`reminders/${_id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Reminders/api.js